import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'productName',
  standalone: true,
})
export class ProductNamePipe implements PipeTransform {
  /**
   * Returns the appropriate product name based on part type
   * - For 'Used Part': returns part_name
   * - For other types (e.g., 'Scrap Part'): returns table_name
   */
  transform(product: any): string {
    if (!product) {
      return '';
    }

    // Check if part_type is 'Used Part'
    if (product.part_type === 'Used Part') {
      return product.part_name || product.table_name || '';
    }

    // For all other part types (Scrap Part, etc.), return table_name
    return product.table_name || product.part_name || '';
  }
}
